import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';

export const wheelSupplierTemplateFormSchema = z.object({
  name: requiredString,
  criteria: z
    .array(
      z.object({
        criterion: z.object({ id: z.string() }),
        values: z.array(requiredString).min(1, {
          error: REQUIRED_MESSAGE,
        }),
      }),
    )
    .min(1, { error: REQUIRED_MESSAGE }),
  suppliers: z
    .array(
      z.object({
        code: z.string().nullable(),
        wyzApiId: z.number(),
        name: z.string(),
        type: z.number(),
        orderable: z.boolean().nullable(),
        customName: z.string().nullish(),
        status: z.string(),
        enabled: z.boolean(),
      }),
    )
    .min(1, {
      error: REQUIRED_MESSAGE,
    }),
});
